import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateBoardResolutionToSell.json';
import FormError from '../../../../view/FormError';
import Meta from '../../../../model/Meta';

class BoardResolutionToSellStep2 extends Component {
    constructor(props) {
        super(props);
        this.state = Data;
		
		this.bods = this.bods.bind(this);
		this.removeBod = this.removeBod.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details,
				meetingDate: data.meetingDate
			},			
				()=>{
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));
					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

	}

	componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(event, radioname=null) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;
	    const name = radioname ? radioname : target.name;

	    this.setState({
			details: {
				property: {
					...this.state.details.property
				},
				corporation: {
                    ...this.state.details.corporation,
                    [name]: value
				}
			},
			formFocus: "corporation_"+name
	    },
	    	()=>{
	    		//console.log("State Change: ", this.state);
	    		//console.log("")
	    		localStorage.setItem(this.state.formId, JSON.stringify(this.state));
	    		this.errorHandle();

	    	}
	    );
    }

	errorHandle() {
		let errorArray = [];

		if(
			!this.state.details.corporation.name ||
			!this.state.details.corporation.address ||
			!this.state.details.corporation.representativeFname ||
			!this.state.details.corporation.representativeMname ||
			!this.state.details.corporation.representativeLname ||
			!this.state.details.corporation.representativePosition ||
			!this.state.details.corporation.meetingDate ||
			(this.state.details.corporation.bod.length ===0)
		) {
			let err = {
				"message": `All fields are required.`
			}
			errorArray.push(err);
		}

		this.setState({
			formError: errorArray
		},(i)=>{
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			//console.log(this.state.formError);
			this.checkCompleteness();		
		})

	}

	checkCompleteness() {

		if(this.state.formError.length>0) {
			$(".next").addClass("disabled");
		} else {
			$(".next").removeClass("disabled");
		}

	}

	bods() {
		let bods = this.state.details.corporation.bod;
		
		if(bods.length > 14) {
			//console.log("BOD is greater than 15", $(".bod-field"));
			$(".bod-field").addClass("d-none");
		} else {
			$(".bod-field").removeClass("d-none");
		}

		return (
			<ul className="list-group">
				<li className="list-group-item"><strong>Board of Directors ({bods.length})</strong></li>
				{
					bods.map((obj, i)=>{
						return(	
							<li key={i} className="list-group-item d-flex justify-content-between align-items-center text-capitalize">
								{obj}
								<button className="btn btn-secondary btn-sm" onClick={(e)=>this.removeBod(e,i)}>
									Remove
								</button>
							</li>
						);
					})
				}				
			</ul>
		)
		
	}
	
	addBod() {
		// Value of the field first
		let val = document.querySelector("#bodInputField").value;
		
		if(val) {

			// Add data to state
			let toArray = [...this.state.details.corporation.bod];
			toArray.push(this.state.details.corporation.tempbod);

			this.setState({	
				details: {
					property: {
						...this.state.details.property
					},
					corporation: {
						...this.state.details.corporation,
						bod: toArray
					},
					formFocus: "corporation_bod"
				}

			}, ()=>{
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));

				this.errorHandle();
				
				// Remove tempbod value on clicked
				this.setState({
					details: {
						property: {
							...this.state.details.property
						},
						corporation: {
							...this.state.details.corporation,
							tempbod: ""
						},
						formFocus: "corporation_bod"
					}
				})

			});

			document.querySelector(".err-bod").classList.add("d-none");

		} else {
			// Add bod is clicked when field is blank, take action on this
			document.querySelector(".err-bod").classList.remove("d-none");
		}
	}

	removeBod(e, i) {
		e.preventDefault();
		let toArray = [...this.state.details.corporation.bod];
		// Array slice, remove item with i index, 1 only
		toArray.splice(i,1);
		this.setState({
			details: {
				property: {
					...this.state.details.property
				},
				corporation: {
					...this.state.details.corporation,
					bod: toArray
				},
				formFocus: "corporation_bod"
			}
		}, ()=> {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
	    	this.errorHandle();
		});
	}
    
    render() {
			const meta = {
				title: "Seller Information - Board Resolution to Sell Contract",
				description: "Enter Seller's Information - Create you custom Board Resolution to Sell Contract for free"
			}
        return(
            <div className="page page-inner page-contract">
						<Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">Board Resolution (to Sell)</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((2/4)*100)} />

                                {/* Form start here */}
                                <form>
                                    {/* Corporation name */}
                                    <div className="form-group">
                                        <label htmlFor="name">
                                            <span className="font-weight-bold">What is the name of the seller corporation?</span><span className="red asterisk">*</span>
                                        </label>
                                        <input className="form-control" name="name" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.name} placeholder="(e.g. ABC corp.)" />
                                    </div>

                                    {/* Corporation Address */}
									<div className="form-group">
										<label htmlFor="address">
											<span className="font-weight-bold">What is the address of the seller corporation's principal office?</span><span className="red asterisk">*</span>
											
										</label>
										<input className="form-control" name="address" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.address} placeholder="(e.g. No. Street, City, Province, Country, Zip Code)" />
									</div>

                                    {/* Corporation representative */}
                                    <br />
									<div>
										<div className="form-group">
											<label htmlFor="representativeFname">
												<span className="font-weight-bold">What is the name of the authorized representative?</span><span className="red asterisk">*</span>
												
											</label>
										</div>
										<div className="form-group">
											<input className="form-control" name="representativeFname" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.representativeFname} placeholder="First Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="representativeMname" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.representativeMname} placeholder="Middle Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="representativeLname" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.representativeLname} placeholder="Last Name" />
										</div>
										<div className="form-group">
											<input className="form-control" name="representativeSuffix" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.representativeSuffix} placeholder="Suffix" />
										</div>
										<div className="form-group">
											<input className="form-control" name="representativePosition" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.representativePosition} placeholder="Position" />
										</div>

										<div className="text-center">
											<div className="form-check form-check-inline mr-2">
												<label className="form-check-label">
													<input 
														className="form-check-input" 
														type="radio" 
														value="Male" 
														onChange={(e)=>this.handleChange(e, "representativeGender")} 
														checked={this.state.details.corporation.representativeGender === 'Male'} 
													/>
														Male
													</label>
											</div>
											<div className="form-check form-check-inline ml-2">
												<label className="form-check-label">
													<input 
														className="form-check-input" 
														type="radio" 
														value="Female" 
														onChange={(e)=>this.handleChange(e, "representativeGender")} 
														checked={this.state.details.corporation.representativeGender === 'Female'} 
													/>
														Female
													</label>
											</div>
										</div>

									</div>

                                    {/* Board meeting */}
                                    <br />
									<div className="form-group">
										<label htmlFor="meetingDate">
											<span className="font-weight-bold">When was the board meeting held giving the power to sell to the authorized representative?</span><span className="red asterisk">*</span>
											
										</label>
										<input className="form-control" name="meetingDate" type="date" onChange={this.handleChange.bind(this)} value={this.state.details.corporation.meetingDate} placeholder="(e.g. 1 January 2017)" />
									</div>

									{/* BODs */}
									<br />
									<div className="form-group">
										<label htmlFor="bod">
											<span className="font-weight-bold">What are the names of all the directors who approved the power to sell to the authorized representative? (maximum of 15 directors)</span><span className="red asterisk">*</span>
											
										</label>

										{this.bods()}

										<div>
											<small>Input one name at a time only. Click the + button to add a director.</small>
										</div>

										<div className="input-group bod-field">
											<input id="bodInputField" className="form-control" name="tempbod" type="text" placeholder="Full Name" value={this.state.details.corporation.tempbod} onChange={this.handleChange.bind(this)} />
											<span className="input-group-btn">
												<button className="btn btn-secondary" type="button" onClick={this.addBod.bind(this)}>
													<i className="fa fa-plus" aria-hidden="true"></i>
												</button>
											</span>
										</div>
										<div className="font-italic d-none text-danger err-bod">
											<small className="text-italic">Please enter full name</small>
										</div>
									</div>

                                </form>

								{/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 2/4</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/1"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/3"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BoardResolutionToSellStep2;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/board-resolution-to-sell/BoardResolutionToSellStep2.js